import React, { Component } from 'react'
import styled from 'styled-components'
import logo from '../assets/images/logo-red.svg'
import logoRed from '../assets/images/logo-red.svg'

const Navbar = styled.div`
  transition: 0.5s all;
  a {
    color: inherit;
  }
  &.scrolled {
    background: white;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
    color: #fc4c4c;
    .logo {
      display: none;
    }
    .logo-red {
      display: block;
    }
    .button {
      border-color: #fc4c4c;
      color: #fc4c4c;
    }
  }
  .button {
    margin-top: -5px;
    position: absolute;
    top: 20px;
    right: 200px;
    width: 200px;
    height: 30px;
    border-radius: 2px;
    font-family: 'Titillium Web', sans-serif;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0);
    outline: none;
    border: 2px solid white;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    color: white;
    background: rgba(0, 0, 0, 0.2);
    font-size: 0.8em;
    transition: 0.3s all;
    cursor: pointer;
    &:hover {
      background: #fc4c4c;
      color: white;
    }
    &:active {
      background: black;
    }
  }
  .logo-red {
    display: none;
  }
  color: white;
  font-weight: 700;
  height: 60px;
  box-sizing: border-box;
  padding: 20px 40px;
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: space-between;
  top: 0;
  font-size: 1.2em;
  z-index: 2;

  .phone {
    line-height: 20px;
  }

  @media screen and (max-width: 850px) {
    height: auto;
    text-align: center;
    height: 60px;
    .logo {
      margin-top: 3px;
    }
    .CTA {
      display: none;
    }
    img {
      height: 15px;
    }
    padding: 20px 20px;
    font-size: 1em;
  }
`
function scrollToCTA() {
  window.scroll({
    top: 0,
    behavior: 'smooth',
  })
}

class _Navbar extends Component {
  componentDidMount() {
    let navbar = document.querySelector('#navbar')

    document.addEventListener('scroll', () => {
      if ((window.pageYOffset > 100) & !navbar.classList.contains('scrolled')) {
        navbar.classList.add('scrolled')
      }
      if ((window.pageYOffset <= 100) & navbar.classList.contains('scrolled')) {
        navbar.classList.remove('scrolled')
      }
    })
  }

  render() {
    return (
      <Navbar id="navbar">
        <div className="logo">
          <img src={logo} alt="Logo de monbanquet.fr" height="20px" />
        </div>
        <div className="logo-red">
          <img src={logoRed} alt="Logo de monbanquet.fr" height="20px" />
        </div>
        <div className="CTA">
          <button className="button" onClick={() => this.props.openModal(0)}>
            Demander un devis
          </button>
        </div>
        <div className="phone">
          <a href="tel: 01 76 44 04 41">01 76 44 04 41</a>
        </div>
      </Navbar>
    )
  }
}

export default _Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js